/****************************************************
 * Module Name:  DraggableList.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableRow, Box, Button } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Constants from '../../utility/constants';
import UserColumnPermissionProxy from '../../utility/proxy/manager/permissionProxy/userColumnPermissionProxy';
import CommonSnackbar from '../common/commonSnackBar';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';

export default class DraggableList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: this.props.items,
      errorSnackbar: false,
      loadingButton: false,
      snackbarVariant: "",
      errorMessage: "",
      successSnackbar: false,
    }
  }

  onDragEnd = (result) => {
    if (!result.destination) return;
    let newList = JSON.parse(JSON.stringify(this.state.data)); // Use list instead of items
    let [reorderedItem] = newList.splice(result.source.index, 1);
    newList.splice(result.destination.index, 0, reorderedItem);
    newList.map((iItem, index) => iItem.content = (index + 1) + " " + iItem.label);
    this.setState({ data: newList });
  };

  handleSave = () => {
    this.setState({ loadingButton: true });
    let columnname = [];
    this.state.data.map(idata => {
      const header = idata.content.split(' ');
      columnname.push(header.slice(1).join(' '));
      return true;
    });

    UserColumnPermissionProxy.ColumnOrderSequence(Constants.loggedInUser.id, columnname, (response) => {
      if (response) {
        this.setState({ errorMessage: response.errorMessage });
        this.setState({ loadingButton: false });
        this.setState({ snackbarVariant: "success" });
        this.setState({ successSnackbar: true })

      } else {
        this.setState({ errorMessage: response.errorMessage });
        this.setState({ snackbarVariant: "error" });
        this.setState({ errorSnackbar: true, loadingButton: false })
      }
    }
    );

    this.getColumnPermissionsForUser();
  };

  getColumnPermissionsForUser = () => {
    try {
      UserColumnPermissionProxy.GetPermissionsForUserInSequence(Constants.loggedInUser.id, (response) => {
        if (response) {
          Constants.USER_COLUMN_PERMISSION = response;
        } else return;
      });
    } catch (error) {

    }
  };

  handleCancel = () => {
    this.setState({ data: this.props.items });
  };

  render() {
    return (
      <div>
        {this.state.successSnackbar ? (
          <CommonSnackbar
            show={true}
            message={<Box>{this.state.errorMessage}</Box>}
            variant={this.state.snackbarVariant}
            autoHide={this.state.snackbarVariant === "success" ? true : false}
            handleClose={() => this.setState({ successSnackbar: false })}
            title={this.state.snackbarVariant}
          />
        ) : null}
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={Constants.APiFailErrorMessage}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          title={"Error"}
          handleClose={() => this.setState({ errorSnackbar: false })}
        />

        <Box>
          <Box mt={2} float='right' width='100%'
            whiteSpace='nowrap'
            flexDirection='row'
            display='flex'
          >
            <LoadingButton
              variant="outlined"
              color="success"
              onClick={this.handleSave}
              loading={this.state.loadingButton}
              loadingPosition="start"
              startIcon={<SaveIcon />}>Save</LoadingButton>
            <Box mx={1} />
            <Button variant="outlined" color="error" onClick={this.handleCancel} disabled={this.state.loadingButton}>Cancel</Button>
          </Box>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center" overflow-Y='scroll' paddingLeft='8px' paddingRight='8px' marginTop='8px' >
          <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <TableContainer sx={{ width: 'auto' }}>
                  <Table sx={{ width: 'auto', padding: '0', borderCollapse: 'collapse', overflowY: 'scroll', }}>
                    <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                      {this.state.data.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index}>
                          {(provided) => (
                            <TableRow
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              ref={provided.innerRef}
                              sx={{
                                '&:hover': {
                                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                },

                              }}
                            >
                              <TableCell sx={{
                                width: 'auto',
                                padding: '8px',
                                border: 'none',

                              }}>
                                <Card
                                  sx={{
                                    backgroundColor: '#F5F5F5',
                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                    transition: 'box-shadow 0.3s ease',
                                    width: '200px',
                                    textAlign: 'left',
                                    padding: '0px',
                                  }}
                                >
                                  <CardContent sx={{ padding: '8px 8px 0px 8px !important' }}>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        color: 'inherit',
                                        fontWeight: '200',
                                        fontSize: 'smaller',
                                      }}
                                    >
                                      <DragIndicatorIcon color="info"
                                        sx={{
                                          paddingLeft: '8px',
                                          paddingBottom: '4px',
                                        }} />
                                      {item.content}
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </TableCell>
                            </TableRow>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Droppable>
          </DragDropContext>
        </Box>

      </div>
    );
  }
}
